<template>
  <b-sidebar
    :id="sbId"
    :visible="sbModel"
    sidebar-class="border-right border-danger"
    right
    shadow
    lazy
    :no-header="true"
  >
    <b-card
        v-if="settings"
      :title="titleDate"
      class="add-publishing"
      style="height:100vh
"
    >
      <!-- BTN -- CASE NUMBER, URLS (OPT)-->

      <!-- PHONE (REQ)-->
      <b-form-group
        id="input-group-1"
        label-for="input-1"
        description="Available for quick search"
      >
        <label id="popover-target-phone-number">
          Phone Number:
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
              fill="#B3C2CB"
          />
          <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
              fill="#B3C2CB"
          />
          <path
              d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
              fill="#B3C2CB"
          />
        </svg>
        </label>
        <b-popover
            id="popover-target-2"
            target="popover-target-phone-number"
            triggers="hover"
            placement="top"
            class="info_popup"
        >
          The phone number of the primary caller or callee on the other end of the line.
        </b-popover>
        <b-form-input
          id="input-1"
          v-model="form.phone"
          type="tel"
          placeholder="Enter Phone "
          required
        />
      </b-form-group>
      <div style="margin-top: 20px; margin-bottom: 20px;">
        <b-button
            class="btn-add-crew"
            :variant="callStarted ? 'danger' : 'success'"
            @click="handleStartEndCallClick"
            style="margin-bottom: 20px"
        >
          {{ startEndCallBtnTxt }}
        </b-button>
      </div>

      <!-- INGOING / OUTGOING -->
      <div class="optional2">
        <div
            :class="`toggler  ${form.isOutgoing ? 'bg' : ''}`"
            @click="handleToggleBounds"
        >
          <div :class="`slider ${form.isOutgoing ? 'btns' : ''}`" />
        </div>
        <p>
          {{ form.isOutgoing ? `Outgoing` : `Incoming` }}
          <span id="popover-target-1">
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                  fill="#B3C2CB"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                  fill="#B3C2CB"
              />
              <path
                  d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                  fill="#B3C2CB"
              />
            </svg>
          </span>
          <b-popover
              target="popover-target-1"
              id="popover-target-2"
              triggers="click"
              placement="bottom"
              class="info_popup"
          >
            Incoming calls are when a company contacts you, while outgoing calls
            occur when you reach out to a company for assistance or information.
          </b-popover>
        </p>
      </div>

      <!-- CONTACT NAME-->
      <b-form-group
          v-if="settings_logContactName"
          id="input-group-1"
          label-for="input-1"
      >
        <label id="popover-target-contact-name">
          Contact Name: <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
              fill="#B3C2CB"
          />
          <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
              fill="#B3C2CB"
          />
          <path
              d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
              fill="#B3C2CB"
          />
        </svg>
        </label>
        <b-popover
            target="popover-target-contact-name"
            id="popover-target-2"
            triggers="hover"
            placement="top"
            class="info_popup"
        >
          The name of the person or organization associated with the phone number, especially useful for identifying callers.
        </b-popover>
        <b-form-input
            id="input-1"
            v-model="form.contactName"
            type="text"
            placeholder="John Doe "
            required
        />
      </b-form-group>

      <!-- CALL RECORDING (OPT)-->
      <b-form-group
          v-if="settings_logCallRecording"
          id="input-group-1"
          label-for="input-1"
      >
        <label id="popover-target-call-recording">
          Recording:
          <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                fill="#B3C2CB"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                fill="#B3C2CB"
            />
            <path
                d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                fill="#B3C2CB"
            />
          </svg>
        </label>
        <b-popover
            id="popover-target-2"
            target="popover-target-call-recording"
            triggers="hover"
            placement="top"
            class="info_popup"
        >
          In-app recording audio of the call.
          It is up to you to abide by the laws in your state. Protocol is to announce
          that the call will be recorded.
        </b-popover>
        <audio-recorder
            :validity-array="[true]"
            record-msg-txt="Record"
            @audio-recorded-info="handleAudioRecordedInfoByCreatedBy"
        />
      </b-form-group>

      <!-- NOTES (REQ)-->
      <b-form-group
          v-if="settings_logNotes"
          id="input-group-1"
          label="Notes:"
          label-for="input-1"
          description="Freely write. Call Log will identify the case # and phone number in your notes."
      >
        <transition name="fadeHeight" mode="out-in">
          <editor
              id="textarea-default"
              v-show="form"
              @input="input"
              :clear="clear"
              :content="form.note"
              @resetClear="resetClear"
          />
        </transition>
      </b-form-group>

      <!-- CALL LOCATION-->
      <b-form-group
          v-if="settings_logCallLocation"
          id="input-group-1"
          label="Contact Location:"
          label-for="input-1"
          description="location"
      >
        <b-form-input
            id="input-1"
            v-model="form.callLocation"
            type="text"
            placeholder="John Doe "
            required
        />
      </b-form-group>

      <!-- CALL PRIORITY-->
      <b-form-group
          v-if="settings_logCallPriority"
          v-slot="{ ariaDescribedby }"
      >
        <label id="popover-target-call-priority">
          Call Priority:
          <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                fill="#B3C2CB"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                fill="#B3C2CB"
            />
            <path
                d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                fill="#B3C2CB"
            />
          </svg>
        </label>
        <b-popover
            id="popover-target-2"
            target="popover-target-call-priority"
            triggers="hover"
            placement="top"
            class="info_popup"
        >
          An indication of the call's importance or urgency.
        </b-popover>
        <b-form-radio-group
            id="btn-radios-2"
            v-model="form.callPriority"
            :options="callPriorityOpt"
            :aria-describedby="ariaDescribedby"
            button-variant="outline-warning"
            size="md"
            name="radio-btn-outline"
            buttons
        ></b-form-radio-group>
      </b-form-group>

      <!-- CALL SOURCE-->
      <b-form-group
          v-if="settings_logCallSource"
          id="input-group-1"
          label-for="input-1"
          description=""
      >
        <label id="popover-target-call-source">
          Call Source:
          <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                fill="#B3C2CB"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                fill="#B3C2CB"
            />
            <path
                d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                fill="#B3C2CB"
            />
          </svg>
        </label>
        <b-popover
            id="popover-target-2"
            target="popover-target-call-source"
            triggers="hover"
            placement="top"
            class="info_popup"
        >
          Information about how the call was initiated, such as through a specific phone line, department, or marketing campaign.
        </b-popover>
        <b-form-input
            id="input-1"
            v-model="form.callSource"
            type="text"
            placeholder=" "
        />
      </b-form-group>

      <!-- FOLLOW UP DATE-->
      <template
          v-if="settings_logFollowUpDate" >
      <hr />
      <b-form-group
          id="input-group-1"
          label-for="input-1"
      >
        <label id="popover-target-follow-up">
          Follow-Up Date and Time::
          <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                fill="#B3C2CB"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                fill="#B3C2CB"
            />
            <path
                d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                fill="#B3C2CB"
            />
          </svg>
        </label>
        <b-popover
            id="popover-target-2"
            target="popover-target-follow-up"
            triggers="hover"
            placement="top"
            class="info_popup"
        >
          If applicable, for scheduling follow-up calls or tasks related to the call. You will receive a reminder email from CallLog.
        </b-popover>
        <b-form-datepicker
            id="follow-up"
            v-model="form.followUpDateTime.date"
            class="mb-2"/>
            <b-time v-model="form.followUpDateTime.time"
                    locale="en"
            />
      </b-form-group>
      <hr />
      </template>

      <!-- CALLER ID / REFERENCE NUMBER (OPT)-->
      <b-form-group
       v-if="settings_logRefNum"
        id="input-group-1"
        label="Reference Number:"
        label-for="input-1"
        description="Can be caller Id or a response to a number given"
      >
        <b-form-input
          id="input-1"
          v-model="form.refNum"
          type="text"
          placeholder="Enter Phone "
          required
        />
      </b-form-group>

      <!-- CALL TYPE (OPT)-->
      <b-form-group
          v-if="settings_logCallType"
          label="Call Type"
          label-for="input-6"
          class="custom-label"
      >
        <vue-bootstrap-typeahead
          v-if="settings_logCallType"
          id="callType"
          ref="callType"
          v-model="form.callType"
          no-resize
          :data="$typeAheadCallTypes"
          placeholder="appointments, refills"
          :serializer="s => `${s.text}`"
          @hit="$event => (form.callType = $event.text)"
        />
      </b-form-group>

      <!-- OBJECTIVE (e.g. SUBJECT, REASON FOR CALL) (OPT)-->
      <b-form-group
        v-if="settings_logObjective"
        id="input-group-1"
        label="Reason:"
        label-for="input-1"
        description="What is the reason or subject of this call?"
      >
        <b-form-input
          id="input-1"
          v-model="form.objective"
          type="text"
          placeholder="Enter purpose of call "
          required
        />
      </b-form-group>

      <!-- CALL OUTCOME (OPT)-->
      <b-form-group
        v-if="settings_logCallOutcome"
        id="input-group-1"
        label="Call Outcome:"
        label-for="input-1"
        description="Good Bad, Follow Up"
      >
        <b-form-input
          id="input-1"
          v-model="form.outcome"
          type="text"
          placeholder="How did it go? "
          required
        />
      </b-form-group>

      <!-- CALL STATUS (OPT)-->
      <b-form-group
          id="call-status"
          v-if="settings_logCallStatus"
          label="Call Status"
          label-for="input-6"
          class="custom-label"
      >
        <vue-bootstrap-typeahead
          id="callStatus"
          ref="callStatus"
          v-model="form.callStatus"
          no-resize
          :data="$typeAheadCallStatuses"
          placeholder="status of your call"
          :serializer="s => `${s.text}`"
          @hit="$event => (form.callStatus = $event.text)"
        />
      </b-form-group>

      <!-- DOCS UPLOAD (OPT)-->
      <b-icon
        icon="file-plus"
        variant="primary"
        scale="1"
        @click="handleAddDocToggle"
        style="cursor:pointer;"
      />
      <label v-if="addDocument"> Add Documents</label>
      <b-form-group
        v-if="addDocument"
        id="fieldset-1"
        description="Add Associated Documents"
        label-for="input-1"
      >
        <img
          v-if="form.imgURL"
          :src="form.imgURL"
          style="height: 150px; border: solid;
            border-width: thin;
             border-radius: 0px;
            object-fit:cover"
          :alt="`${form.phone} cover`"
        />
        <image-upload
          v-else
          ref="image-upload"
          :img-upload-idx="idx"
          img-upload-type="photo"
          :storage-path="storagePath"
          :max-image="1"
          :show-edit="true"
          :show-delete="true"
          style="margin-left: 50px; margin-right: 50px;"
          @img-uploaded-url="handleImgUploadedURL"
        />
      </b-form-group>

      <div style="margin-top: 20px; margin-bottom: 100px;">
        <b-button
          class="btn-add-crew"
          @click="handleLogClick"
          variant="warning"
          style="margin-bottom: 20px"
        >
          Log Call
        </b-button>
      </div>
      <b-card v-if="!production" class="mt-3" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card>
    </b-card>
    <template #footer>
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">
          <p>{{ time }} | {{ callDuration }}</p>
        </strong>
        <b-button size="sm" @click="handleCloseSideBar">Close </b-button>
      </div>
    </template>
    <div></div>
  </b-sidebar>
</template>
<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import DefaultPlayList from "@/components/blockResources/resourcePlayList/assets/json/defaultPlayList.json";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import AudioRecorder from "@/components/blockResources/_components/audioRecorder"
export default {
  name: "CallLog_FormSideBar",
  mixins: [UploadImage],
  components: {
    ImageUpload,
    Editor,
    AudioRecorder,
    VueBootstrapTypeahead
  },
  props: {
    sbId: {
      type: String,
      required: true
    },
    sbModel: {
      type: Boolean,
      required: true
    },
    resource: {
      type: Object,
      required: ()=>{return {}}
    },
    settings: {
      type: Object,
      required: ()=>{return {}}
    },
    items: {
      type: Array,
      default: () => [],
      required: false
    },
    assetsUrlHome: {
      type: String,
      default: "",
      required: false
    },
    updatedAt: {
      type: String,
      default: "",
      required: false
    }
  },
  created() {},
  mounted() {
    this.form = this.defaultForm; //@TODO do I need to deepclone ?
    //Time
    this.handlePollTime();

    this.form._created_at = new Date();
    let createdBy = this.form._created_by;
    createdBy.uid = this.user.id ? this.user.id : "XTETE";
    createdBy.name = `${this.profile.firstname} ${this.profile.lastname}`;
    createdBy.imgURL = this.profile.imgURL;
    createdBy.relation = "Uncle";
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      apps: "user/apps",
      userData: "user/appsData"
    }),
    settings_logCallLocation() {
      return this.settings && this.settings.user
          ? this.settings.user._logCallLocation
          : true;
    },
    settings_logCallOutcome() {
      return this.settings && this.settings.user
          ? this.settings.user._logCallOutcome
          : true;
    },
    settings_logCallPriority() {
      return this.settings && this.settings.user
          ? this.settings.user._logCallPriority
          : true;
    },
    settings_logCallRecording() {
      return this.settings && this.settings.user
          ? this.settings.user._logCallRecording
          : true;
    },
    settings_logCallSource() {
      return this.settings && this.settings.user
          ? this.settings.user._logCallSource
          : true;
    },
    settings_logCallStatus() {
      return this.settings && this.settings.user
          ? this.settings.user._logCallStatus
          : true;
    },
    settings_logCallType() {
      return this.settings && this.settings.user
          ? this.settings.user._logCallType
          : true;
    },
    settings_logContactName() {
      return this.settings && this.settings.user
          ? this.settings.user._logContactName
          : true;
    },
    settings_logFollowUpDate() {
      return this.settings && this.settings.user
          ? this.settings.user._logFollowUpDate
          : true;
    },
    settings_logNotes() {
      return this.settings && this.settings.user
          ? this.settings.user._logNotes
          : true;
    },
    settings_logObjective() {
      return this.settings && this.settings.user
          ? this.settings.user._logObjective
          : true;
    },
    settings_logRefNum() {
      return this.settings && this.settings.user
          ? this.settings.user._logRefNum
          : true;
    },
    startEndCallBtnTxt() {
      return this.callStarted
        ? `END CALL (${this.callDuration} )`
        : `START CALL`;
    },
    callDuration() {
      return new Date(this.duration * 1000).toISOString().slice(11, 19);
    },
    /***TIME - move to top Level component */
    time() {
      return this.hours + ":" + this.minutes + ":" + this.seconds;
    },
    milliseconds: function() {
      return this.currentTime;
    },
    hours: function() {
      var milli = this.milliseconds;
      // Doing the math
      // var hrs = Math.floor((milli / 3600000) % 24);
      // Using getHours()
      var hrs = new Date().getHours();
      if (hrs >= 13) {
        hrs = hrs - 12;
      }
      return hrs >= 10 ? hrs : "0" + hrs;
    },
    minutes() {
      var milli = this.milliseconds;
      var min = Math.floor((milli / 60000) % 60);
      return min >= 10 ? min : "0" + min;
    },
    seconds() {
      var milli = this.milliseconds;
      var sec = Math.ceil((milli % 60000) / 1000).toFixed(0);
      //if (sec == 60) { sec = 00 }
      return sec >= 10 ? sec : "0" + sec;
    },
    day() {
      return "TUESDAY";
    },
    timeOfDay() {
      return "morning";
    },
    date() {
      //Settings could ask o
      return moment(Date.now())().format("MM/DD/YYYY");
    },
    /**** Validations ****/
    state() {
      return true;
      return this.form.phone.length >= 10;
    },
    invalidFeedback() {
      if (this.form.phone.length > 0) {
        return "Enter at least 4 characters.";
      }
      return "Please enter something.";
    },
    /* USERDATA */
    titleDate() {
      //"dddd, MMMM DD  YYYY"
      return moment(new Date()).format("MMMM DD YYYY");
    },
    userDataPhotos() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].photos
        ? this.userData[`app_${this.resource.toolId}`].photos
        : DefaultPlayList;
    }
  },
  methods: {
    handlePollTime() {
      let that = this;
      this.timePolling = setInterval(() => {
        that.currentTime = Date.now();
        if (that.callStarted) that.duration++;
      }, 1000);
    },
    handleToggleBounds() {
      this.form.isOutgoing = !this.form.isOutgoing;
    },
    /**/
    handleAudioRecordedInfoByCreatedBy(info){
      debugger;
      if(this.form && this.form.audio){
        this.form.audio = info;
      }
      this.form._added_audio_at = new Date();
    },
    handleAddDocToggle() {
      this.addDocument = !this.addDocument;
    },
    handleImgUploadedURL(idx, url) {
      this.form.imgURL = url;
      this.form.docs.push(url);
    },
    resetForm() {
      debugger;
      this.form = null;
      this.form = _.clone(this.defaultForm);
    },
    input(val) {
      this.form.note = val.content;
    },
    handleItemClick(item) {
      this.$emit("item-clicked", item);
    },
    handleLogClick() {
      this.$emit("log-form-click", this.form);
      this.resetForm();
      this.handleCloseSideBar();
    },
    handleStartEndCallClick() {
      this.callStarted = !this.callStarted;
      if (this.callStarted) {
        this.form._started_at.push[Date.now()];
      } else {
        this.form._ended_at.push[Date.now()];
      }
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.$emit("close-clicked");
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      production: true,
      callStarted: false,
      duration: 0,
      /*** TIME ***/
      timePolling: null,
      currentTime: Date.now(),
      changes: null,
      /*** TIME****/
      addDocument: false,
      idx: 0,
      docs: [],
      msgs: [
        "A photo is worth a thousand words",
        "A Photo is a memory saved",
        "Nice Photo"
      ],
      storagePath: "app_calllog_docs",
      clear: false,
      form: {},
      defaultForm: {
        _created_at: 1234,
        _started_at: [],
        _ended_at: [],
        phone: "",
        contactName: "",
        callPriority:"",
        callSource:"",
        followUpDateTime:{
          date:'',
          time:''
        },
        callLocation:"",
        audio:{},
        isOutgoing: true,
        note: [],
        callType: "",
        callStatus: "",
        refNum: "",
        objective: "", //Subject/Reason- Objective is more purposeful,
        outcome: "",
        status: "",
        docs: [],
        imgURL: "", //temp
        _created_by: {
          uid: "",
          name: "",
          imgURL: "",
          relation: ""
        }
      },
      callPriorityOpt:[
        {
          "value": "urgent",
          "text": "Urgent",
          "color":"red",
          "_created_at": 1234
        },
        {
          "value": "high",
          "text": "High",
          "_created_at": 1234
        },
        {
          "value": "medium",
          "text": "Medium",
          "_created_at": 1234
        },
        {
          "value": "low",
          "text": "Low",
          "_created_at": 1234
        }
      ],
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.optional2 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;
    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
</style>
